const s = {
  name: "CheckoutApiOnly",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,2h35V0H0V2z"/>
		<path class="st0" d="M0,14h40v-2H0V14z"/>
		<path class="st0" d="M40,26H0v-2h40V26z"/>
		<path class="st0" d="M19,35.4l5.7-5.7l-1.4-1.4L19,32.6l-2.3-2.3l-1.4,1.4L19,35.4z"/>
		<path class="st0" d="M0,33h4v-2H0V33z"/>
		<path class="st0" d="M35,20H24v-2h11V20z"/>
		<path class="st0" d="M21,40H0v-2h21V40z"/>
		<path class="st0" d="M0,20h21v-2H0V20z"/>
		<path class="st0" d="M11,8H0V6h11V8z"/>
		<path class="st0" d="M29,40h11v-2H29V40z"/>
		<path class="st0" d="M40,31v2h-4v-2H40z"/>
		<path class="st0" d="M24,40h2v-2h-2V40z"/>
		<path class="st0" d="M16,8h-2V6h2V8z"/>
		<path class="st0" d="M38,2h2V0h-2V2z"/>
		<path class="st0" d="M40,20h-2v-2h2V20z"/>
		<path class="st0" d="M19,8h21V6H19V8z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CheckoutApiOnly
};
